import { trackAnalyticsEvent } from '@jsmdg/tracking';

export function trackSlide(direction, category) {
    trackAnalyticsEvent({
        category,
        action: 'Slide',
        label: direction,
    });
}
